import React from 'react';
import ActionCard, { ActionCardVariant } from 'components/Common/Cards/ActionCard';
import ProgressBar from 'components/Common/ProgressBar';
import Skeleton from 'components/Common/Skeleton';
import { formatMonetaryAmount } from 'utils/formatMonetaryAmount';

import styles from './LoanProgressCard.module.scss';

interface LoanProgressCardProps {
  isLoading: boolean;
  periodsRemaining: number;
  principalBalance: number;
  totalLoanAmount: number;
  paymentsMade: number;
  totalPayments: number;
}

const LoanProgressCard: React.FC<LoanProgressCardProps> = ({
  isLoading,
  periodsRemaining,
  principalBalance,
  totalLoanAmount,
  paymentsMade,
  totalPayments,
}) =>
  principalBalance > 0 ? (
    <div className={styles.section}>
      <p className={styles.sectionTitle}>Progress</p>

      <ActionCard variant={ActionCardVariant.White}>
        <ActionCard.Col className={styles.progressCardContainer}>
          {isLoading ? (
            <>
              <ActionCard.Row className={styles.progressCardInfoContainer}>
                <Skeleton width="140px" height="20px" mt="2px" />
                <div className={styles.progressCardAmountContainer}>
                  <Skeleton width="80px" height="16px" mr="8px" />
                  <Skeleton width="50px" height="16px" />
                </div>
              </ActionCard.Row>
              <Skeleton width="100%" height="10px" mt="4px" />
            </>
          ) : (
            <>
              <ActionCard.Row className={styles.progressCardInfoContainer}>
                <ActionCard.Title>{periodsRemaining} payments left</ActionCard.Title>
                <ActionCard.Description className={styles.progressCardAmountContainer}>
                  <span className={styles.progressCardAmount}>{formatMonetaryAmount(principalBalance, true)}</span>
                  <span className={styles.progressCardAmountTotal}>/{formatMonetaryAmount(totalLoanAmount, true)}</span>
                </ActionCard.Description>
              </ActionCard.Row>
              <ProgressBar current={paymentsMade} total={totalPayments} />
            </>
          )}
        </ActionCard.Col>
      </ActionCard>
    </div>
  ) : null;

export default LoanProgressCard;
